wbApp.factory('rfidDeviceRegistrationSvc', ['$resource', '$q', 'repositorySvc',
    function ($resource, $q, repositorySvc) {
        var RfidDevices = $resource('restapi/rfid-devices/:id', {}, {
            'getAll': { method: 'GET', isArray: true, url: '/restapi/rfid-devices' },
            'update': { method: 'PUT', url: 'restapi/rfid-devices/:id' },
        });

        function getAllAsync() {
            return repositorySvc.customGet('getAll', RfidDevices);
        }

        function update(model) {
            return repositorySvc.customPutWithParams(
                'update',
                RfidDevices,
                { id: model.id },
                model);
        }

        return {
            getAllAsync: getAllAsync,
            update: update
        }
    }]);